import { observable, action, computed } from 'mobx';
import { app } from '../App';
import { ISettingsApiResponse, ISetting, ESettingStatus } from '../../../common/interfaces/configuration';

export class Configuration {
    @observable public loading: boolean = false;
    @observable public settings: ISetting[] = [];

    @computed
    private get settingsKeys(): string[] {
        return this.settings.map(setting => setting.key);
    }

    @action
    public fetchSettings = async () => {
        try {
            this.loading = true;

            const service = await app.service('settings');
            const settings = (await service.find({ query: { $limit: 9999 } })) as ISettingsApiResponse;

            this.settings = settings.data.map(setting => ({
                key: setting.key,
                value: setting.value || '',
                description: setting.description || '',
                isRequired: false,
                status: ESettingStatus.None
            }));

            this.loading = false;

            return true;
        } catch (error) {
            console.error(error);
            return error;
        }
    };

    @action
    public saveChangedValue = async (key: string, value: string): Promise<boolean> => {
        try {
            value = value.trim();

            let settingFound = this.settingsKeys.indexOf(key);

            if (settingFound !== -1) {
                this.settings[settingFound].status = ESettingStatus.Saving;
            }

            const service = await app.service('settings');
            const patch = await service.patch(key, {
                value
            });

            settingFound = this.settingsKeys.indexOf(key);
            if (settingFound !== -1) {
                this.settings[settingFound].value = value;
                this.settings[settingFound].status = ESettingStatus.Success;

                setTimeout(() => {
                    settingFound = this.settingsKeys.indexOf(key);
                    if (settingFound !== -1 && this.settings[settingFound].status === ESettingStatus.Success) {
                        this.settings[settingFound].status = ESettingStatus.None;
                    }
                }, 2048);
            }

            return true;
        } catch (error) {
            const settingFound = this.settingsKeys.indexOf(key);
            if (settingFound !== -1) {
                this.settings[settingFound].status = ESettingStatus.Error;
            }

            console.error(error);
            return error;
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/stores/Configuration.ts